// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names */
import type { FetchedCurrencies } from "@kiwicom/nitro/lib/records/Currency"

export default function (amount: number, currency: string, currencies: FetchedCurrencies) {
  return parseFloat(
    (amount / currencies[currency].rate).toFixed(Number(currencies[currency].precision)),
  )
}
